import { ChangeEvent, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { ErrorMessage } from '@/components/Message/ErrorMessage';
import './styles.css';

interface CheckboxProps
  extends React.PropsWithRef<JSX.IntrinsicElements['input']> {
  text?: string | React.ReactNode;
  disabled?: boolean;
  containerClassName?: string;
  innerWrapperClassName?: string;
  textClassName?: string;
  checkboxClassName?: string;
  errorMessage?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      text,
      disabled,
      errorMessage,
      containerClassName,
      innerWrapperClassName,
      textClassName,
      checkboxClassName,
      onChange,
      ...rest
    },
    ref
  ) => {
    return (
      <div
        className={twMerge('flex flex-1 flex-col gap-0.75', containerClassName)}
      >
        <label
          className={twMerge(
            'form-label flex items-center gap-2.5 text-nowrap hover:cursor-pointer',
            innerWrapperClassName
          )}
        >
          <input
            ref={ref}
            className={twMerge(
              'customized-checkbox checkbox hover:cursor-pointer',
              checkboxClassName
            )}
            type="checkbox"
            disabled={disabled}
            onChange={onChange}
            {...rest}
          />
          {text && (
            <span
              className={twMerge('font-normal text-[13.5px]', textClassName)}
            >
              {text}
            </span>
          )}
        </label>
        {errorMessage && <ErrorMessage message={errorMessage} />}
      </div>
    );
  }
);
